import React from 'react'
import styled from 'styled-components'
import Text, { useTranslations } from '../../utils/Text'

const Container = styled.div`
  margin: 1.2px 10px 96px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const Button = styled.a`
  color: ${props =>
    props.btnColor ? `${props.btnColor}` : '#414141'} !important;
  margin: 0 1px 6px 0;
  font-family: Muli;
  font-size: 13px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 1px;
  touch-action: manipulation;
  cursor: pointer;
  border-bottom: 2px solid #414141;
  &:hover {
    text-decoration: none !important;
  }
  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }
  &:active {
    opacity: 0.7;
  }
`

export default function CopyToClipboard({
  btnText,
  btnBg,
  btnColor,
  btnMarginT,
  btnMarginB,
  btnWidthMobile,
  btnWidth,
  optional,
  clipboardText,
}) {
  const textToShow = useTranslations(btnText, { optional })

  if (optional && textToShow === null) return null
  return (
    <Container btnMarginT={btnMarginT} btnMarginB={btnMarginB}>
      <div>
        <Button
          btnBg={btnBg}
          btnColor={btnColor}
          btnWidth={btnWidth}
          btnWidthMobile={btnWidthMobile}
          onClick={() => {
            navigator.clipboard.writeText(clipboardText).then()
          }}
        >
          <Text id={btnText} />
        </Button>
      </div>
    </Container>
  )
}
